import * as TYPE from "../../constants";

const initialState = {
  loading: false,
  users: {},
  error: "",
};

export const userListReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.GET_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TYPE.GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      };
    case TYPE.GET_USERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
